<template>
  <div class="nav-bar">
    <div class="nav-top">
      <div class="nav-logo">
        <img
          class="logo"
          v-for="(item, index) in topInfo.ATLAS?.children"
          :key="index"
          :src="$urlImg(item.message)"
          alt=""
          @click="openUrl(item.externalLink)"
        />
      </div>
      <div class="emil-phone">
        <div class="num-item" @click="openOtherUrl">
          <img src="../assets/image/emil.png" alt="" />
          <div class="num">
            {{ topInfo.MODULE_RIGHT?.SERVICE_EMAIL?.message }}
          </div>
        </div>
        <div class="gang"></div>
        <div class="num-item" @click="openOtherUrl2">
          <img src="../assets/image/phone.png" alt="" />
          <div class="num">
            {{ topInfo.MODULE_RIGHT?.SERVICE_PHONE?.message }}
          </div>
        </div>
      </div>
    </div>
    <div class="tablist">
      <div
        class="logoname"
        @click="openHome"
        :class="this.language == 'ZH' ? 'logoname-act' : ''"
      >
        <img
          class="logo-pic"
          :src="$urlImg(topInfo.MODULE_RIGHT?.COMMON_LOGO?.message)"
          alt=""
        />
      </div>
      <div class="lists">
        <div
          class="tab-item"
          v-for="(item, index) in tabList"
          :key="index"
          @click="seleTab(item, index)"
          v-on:mouseover="seleTab2(item, index)"
          v-on:mouseout="gyzxhoverClose(item)"
        >
          <div class="tab">
            <div class="tab-tlt">{{ item.title }}</div>
            <div class="gang" v-if="tabIdx == index"></div>
          </div>
          <img
            class="tab2"
            v-if="
              item.title === '产品' ||
              item.title === '生产研发' ||
              item.title === 'Production R&D' ||
              item.title === 'Product'
            "
            src="../assets/image/tab2.png"
            alt=""
          />
          <div
            class="two-tab"
            v-show="
              item.twoShow &&
              (item.title === '产品' ||
                item.title === '生产研发' ||
                item.title === 'Production R&D' ||
                item.title === 'Product')
            "
          >
            <div
              class="two-item"
              @click.stop="seleTwoTab(item2)"
              v-for="(item2, index) in item.children"
              :key="index"
            >
              {{ item2.name }}
            </div>
            <!-- <div class="two-item" @click.stop="seleTwoTab(1)">服务</div> -->
          </div>
        </div>
      </div>
      <!-- <div class="language">
        <div class="lang" @click="translate">
          <img
            v-if="language == 'EN'"
            class="gq"
            src="../assets/image/lang.png"
            alt=""
          />
          <img v-else class="gq" src="../assets/image/zh.png" alt="" />
          <div class="lang-tlt">{{ language }}</div>
        
        </div>
       
      </div>
      <img
        @click="openSearch"
        class="search"
        src="../assets/image/search.png"
        alt=""
      /> -->
    </div>
    <!-- 首页不显示“联系我们”，其他页面显示 -->
    <!-- <div v-if="$route.path !== '/'" class="lianxi-btn">
      <div class="lx-btn" @click="goLianxiwomen">
        {{ $t("navs.ContactUs") }}
      </div>
    </div> -->
    <!-- <div v-if="searchShow" class="searchput">
      <input
        v-model="keyword"
        type="text"
        placeholder="What are you looking for?"
      />
      <img
        @click="openSearch2"
        class="search2"
        src="../assets/image/search.png"
        alt=""
      />
    </div> -->
  </div>
</template>

<script>
import { aboutModuleInfo, getCategories } from "@/api/index";
export default {
  data() {
    return {
      lianxiShow: true,
      keyword: "",
      headclass: "headerbox",
      language: "EN",
      isScrolled: false, // 是否滚动
      topInfo: {},
      langListShow: false,
      searchShow: false,
      tabIdx: 0,
      twoTab: undefined,
      tabList: [
        {
          title: this.$i18n.t("navs.home"),
          path: "/",
        },
        {
          title: this.$i18n.t("navs.product"),
          twoShow: false,
          path: "/goodsList",
          children: [],
        },
        {
          // /technology
          title: this.$i18n.t("navs.ts"),
          twoShow: false,
          children: [
            // {
            //   name: this.$i18n.t("navs.Technology"),
            // },
            {
              name: this.$i18n.t("navs.Services"),
            },
            {
              name: this.$i18n.t("navs.case"),
            },
            {
              name: "FAQ",
            },
          ],
        },
        {
          title: this.$i18n.t("navs.news"),
          path: "/NewsList",
        },
        {
          title: this.$i18n.t("navs.AboutUs"),
          path: "/aboutUs",
        },
        {
          title: this.$i18n.t("navs.ContactUs"),
          path: "/ContactView",
        },
      ],
      lastScrollPosition: 0, // 记录上一次滚动的位置
      threshold: 10, // 滚动超过这个距离开始隐藏/显示导航栏
      showBtnThreshold: 10, // 向上滚动超过这个距离显示 .lianxi-btn
    };
  },
  computed: {
    selectedNav() {
      return this.$store.state.navIdx;
    },
  },
  watch: {
    selectedNav(newVal) {
      this.tabIdx = newVal;
    },
    // 路由变化时，重新设置 body 的补偿，避免首次挂载时路径尚未就绪导致误判
    // "$route.path"() {
    //   this.setPaddingByRoute();
    // },
  },
  created() {
    this.aboutModuleInfo();
    this.getCategories();
    const newnavIdx =
      this.$store.state.navIdx || sessionStorage.getItem("navIdx");
    console.log("newnavIdxnewnavIdx", newnavIdx);
    if (newnavIdx !== null) {
      this.tabIdx = newnavIdx;
    }
    if (localStorage.getItem("lang") == "zh") {
      this.language = "EN";
    } else {
      this.language = "ZH";
    }
    
  },
  mounted() {
    this.lastScrollPosition =
      window.scrollY || document.documentElement.scrollTop;
    this.threshold = 50; // 设置滚动阈值

    window.addEventListener("scroll", this.handleScroll);
    // 初始化：首页不加补偿，其它页面按默认 228px
    // this.$nextTick(() => {
    //   this.setPaddingByRoute();
    // });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 根据当前路由为 body 设置补偿
    setPaddingByRoute() {
      const isHome = this.$route && this.$route.path === "/";
      const paddingValue = isHome ? "0.70833rem" : "1.1875rem";
      document.body.style.setProperty("padding-top", paddingValue, "important");
    },
    openOtherUrl() {
      window.open(
        this.topInfo.MODULE_RIGHT?.SERVICE_EMAIL?.externalLink,
        "noopener,noreferrer"
      );
    },
    openOtherUrl2() {
      window.open(
        this.topInfo.MODULE_RIGHT?.SERVICE_PHONE?.externalLink,
        "noopener,noreferrer"
      );
    },
    openHome() {
      window.open(
        this.topInfo.MODULE_RIGHT?.COMMON_LOGO?.externalLink,
        "noopener,noreferrer"
      );
    },
    goLianxiwomen() {
      this.tabIdx = 5;
      this.$router.push(
        {
          path: "/ContactView",
        },
        () => {}
      );
    },
    openSearch2() {
      // if (this.keyword == '') {
      //   this.$message({
      //     message: '请输入内容',
      //     duration: 20000,
      //     center: true
      //   })
      // } else {
      this.searchShow = !this.searchShow;
      this.$router.push(
        {
          path: "/search",
          query: { keyword: this.keyword },
        },
        () => {}
      );
      this.searchShow = false; // 提交后隐藏搜索框
      // }
    },

    translate() {
      if (localStorage.getItem("lang") == "zh") {
        localStorage.setItem("lang", "en");
        this.language = "EN";
      } else {
        localStorage.setItem("lang", "zh");
        this.language = "ZH";
      }
      console.log("this.languagethis.language", this.language);
      this.$i18n.locale = localStorage.getItem("lang", "zh");
      // this.categoriesNav()
      window.location.reload();
    },
    getCategories() {
      getCategories({
        language: localStorage.getItem("lang"),
      }).then((res) => {
        if (res.code == 200) {
          console.log(res);
          this.tabList.forEach((ele) => {
            if (ele.title == "产品" || ele.title == "Product") {
              ele.children = res.data;
            }
          });
        }
      });
    },
    handleScroll() {
      const navTop = document.querySelector(".nav-top");
      const tablist = document.querySelector(".tablist");
      const lianxiBtn = document.querySelector(".lianxi-btn");
      const searchputBtn = document.querySelector(".searchput");
      const navbar = document.querySelector(".nav-bar");
      const body = document.body;

      const currentScrollPosition =
        window.scrollY || document.documentElement.scrollTop;
      const scrollDifference = this.lastScrollPosition - currentScrollPosition;

      // 动态调整body的padding-top：首页不加补偿，其它页面为 228px；固定时统一 136px
      if (lianxiBtn && lianxiBtn.classList.contains("fixed")) {
        body.style.setProperty("padding-top", "136px", "important");
      } else {
        // navbar?.classList.remove("heights");
        // const paddingValue = this.$route.path === "/" ? "0.70833rem" : "1.1875rem";
        // body.style.setProperty("padding-top", paddingValue, "important");
      }

      // 控制导航显示/隐藏
      if (currentScrollPosition > this.threshold) {
        if (scrollDifference < 0) {
          // 向下滚动
          navTop?.classList.add("hide");
          tablist?.classList.add("hide");
          navbar?.classList.add("heights");
        } else if (scrollDifference > 5) {
          // 向上滚动
          navTop?.classList.remove("hide");
          tablist?.classList.remove("hide");
          lianxiBtn?.classList.remove("fixed");
          searchputBtn?.classList.remove("fixed");
          navbar?.classList.remove("heights");
        }
      } else {
        // 在顶部区域
        navTop?.classList.remove("hide");
        tablist?.classList.remove("hide");
        lianxiBtn?.classList.remove("fixed");
        searchputBtn?.classList.remove("fixed");
      }

      // 固定联系按钮
      if (scrollDifference < 0 && currentScrollPosition > 136) {
        lianxiBtn?.classList.add("fixed");
        searchputBtn?.classList.add("fixed");
      }

      this.lastScrollPosition = Math.max(currentScrollPosition, 0);
    },

    handleScroll3() {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      // 设置一个阈值，例如滚动超过 100px 后隐藏导航栏
      this.isScrolled = scrollTop > 100;
    },
    openUrl(url) {
      window.open(url, "_blank", "noopener,noreferrer");
    },
    aboutModuleInfo() {
      aboutModuleInfo({
        language: localStorage.getItem("lang"),
        moduleCode: "COMMON",
      }).then((res) => {
        if (res.code == 200) {
          this.topInfo = res.data.PAGE_HEAD;
        }
      });
    },
    seleTab(item, e) {
      console.log("item, e11", item, e);
      if (item.path) {
        this.tabIdx = e;
        sessionStorage.setItem("navIdx", this.tabIdx);
        this.$router.push(
          {
            path: item.path,
          },
          () => {}
        );
      }
    },
    seleTab2(item, index) {
      // this.tabIdx = index
      console.log(index);
      item.twoShow = true;
    },
    gyzxhoverClose(item) {
      item.twoShow = false;
      // this.tabIdx = undefined
    },
    openSearch() {
      this.searchShow = !this.searchShow;
    },
    // 全局点击事件处理函数
    handleGlobalClick(event) {
      const componentRoot = this.$el; // 获取组件根元素

      // 如果点击发生在组件外部且 searchShow 为 true，则关闭 div
      if (!componentRoot.contains(event.target) && this.searchShow) {
        this.searchShow = false;
      }
    },
    seleTwoTab(item) {
      if (item.name == "技术" || item.name == "Technology") {
        this.tabIdx = 2;
        sessionStorage.setItem("navIdx", 2);
        this.$router.push(
          {
            path: "/technology",
          },
          () => {}
        );
      } else if (item.name == "研发" || item.name == "R&D") {
        this.$router.push(
          {
            path: "/service",
            // query: { id: e }
          },
          () => {}
        );
      } else if (item.name == "生产" || item.name == "Produce") {
        this.$router.push(
          {
            path: "/case",
            // query: { id: e }
          },
          () => {}
        );
      } else if (item.name == "FAQ") {
        this.$router.push(
          {
            path: "/problem",
            // query: { id: e }
          },
          () => {}
        );
      } else {
        this.tabIdx = 1;
        sessionStorage.setItem("navIdx", 1);
        this.$router.push(
          {
            path: "/introduce",
            query: { id: item.id },
          },
          () => {}
        );
      }
    },
  },
};
</script>
<style>
body {
  /* padding-top: 0.70833rem !important; */
  padding-top: 136px !important;
}
</style>
<style scoped lang="scss">
::v-deep .el-message {
  z-index: 100000;
  position: relative;
  top: 500px;
}

/* 当.lianxi-btn固定时减少补偿（因为它已脱离文档流） */
.lianxi-btn.fixed ~ * body {
  // padding-top: 136px; /* = nav-top(46) + tablist(90) */
}
.nav-bar {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
  // box-shadow: 0px 4px 10px 0px rgba(113, 135, 152, 0.1);
  transition: all 0.3s ease;
  box-sizing: border-box;
  .nav-top {
    width: 100%;
    height: 46px;
    background: #f4f4f4;
    padding: 0 240px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    will-change: transform;
    transition: transform 0.3s ease;
    transform: translateY(0);
    .nav-logo {
      display: flex;
    }
    .logo {
      width: 26px;
      height: 26px;
      margin-right: 12px;
      cursor: pointer;
      display: block;
    }
    .emil-phone {
      height: 100%;
      display: flex;
      align-items: center;
      .num-item {
        display: flex;
        align-items: center;
        cursor: pointer;
        img {
          width: 16px;
          height: 20px;
          display: block;
          margin-right: 6px;
        }
        .num {
          font-family: Poppins, Poppins;
          font-weight: 400;
          font-size: 12px;
          color: #666666;
          line-height: 17px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }
      .gang {
        width: 0px;
        height: 16px;
        border: 1px solid #5c6a92;
        margin: 0 7px;
      }
    }
  }
  .tablist {
    // width: 100;
    height: 90px;
    background: #ffffff;
    padding: 0 240px;
    display: flex;
    // justify-content: space-between;
    align-items: center;
    will-change: transform;
    transition: transform 0.3s ease;
    transform: translateY(0); // 默认显示
    z-index: 9999999;
    position: relative;
    .logoname {
      width: 208px;
      height: 90px;
      margin-right: 30px;
      flex-shrink: 0;
      cursor: pointer;
      .logo-pic {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }
    .logoname-act {
      margin-right: 100px;
    }
    .lists {
      width: auto;
      height: 100%;
      display: flex;
      align-items: center;
      margin-right: 38px;
      padding-top: 29px;
      // background: #ccc;
      z-index: 9999999;
      position: relative;
      .tab-item {
        width: fit-content;
        height: 100%;
        display: flex;
        // align-items: center;
        margin-right: 80px;
        position: relative;
        flex-shrink: 0;
        cursor: pointer;
        .tab {
          height: 100%;
          .tab-tlt {
            width: fit-content;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 18px;
            color: #3d3d3d;
            line-height: 21px;
            text-align: center;
            font-style: normal;
            text-transform: none;
            margin-bottom: 6px;
          }
          .gang {
            width: 100%;
            height: 4px;
            background: #0d7cd6;
            border-radius: 30px 30px 30px 30px;
          }
        }
        .tab2 {
          width: 11px;
          height: 9px;
          margin-left: 4px;
          display: block;
          margin-top: 6px;
          z-index: 999999;
          background: #ffffff;
        }
        .two-tab {
          width: 178px;
          height: auto;
          border-radius: 0px 0px 0px 0px;
          border: 1px solid #ffffff;
          position: absolute;
          background: #ffffff;
          left: 0;
          top: 60px;
          z-index: 99999999;
          .two-item {
            width: 100%;
            height: auto;
            border-radius: 0px 0px 0px 0px;
            // border: 1px solid #f4f4f4;
            padding: 0 14px;
            font-family: Inter, Inter;
            font-weight: 400;
            font-size: 18px;
            color: #3d3d3d;
            line-height: 32px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            background: #ffffff;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-bottom: 15px;
          }
          .two-item:hover {
            background: #0d7cd6;
            color: #ffffff;
          }
        }
      }
    }
    .language {
      height: 100%;
      padding-top: 23px;
      position: relative;
      .lang {
        width: 108px;
        height: 43px;
        background: #f4f4f4;
        border-radius: 30px 30px 30px 30px;
        padding: 0 11px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        .gq {
          width: 20px;
          height: 20px;
        }
        .lang-tlt {
          font-family: Poppins, Poppins;
          font-weight: 400;
          font-size: 12px;
          color: #666666;
          line-height: 30px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
        .tab22 {
          width: 11px;
          height: 9px;
        }
      }
      .lang-list {
        width: 108px;
        height: 86px;
        background: #f4f4f4;
        // border-radius: 30px 30px 30px 30px;
        position: absolute;
        left: 0;
        bottom: -88px;
        .lang-item {
          padding: 0 11px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .gq {
            width: 20px;
            height: 20px;
          }
          .lang-tlt {
            font-family: Poppins, Poppins;
            font-weight: 400;
            font-size: 12px;
            color: #666666;
            line-height: 30px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
        }
      }
    }
    .search {
      width: 36px;
      height: 36px;
      margin-left: 30px;
    }
  }
  .lianxi-btn {
    width: 100%;
    height: 92px;
    background: #f4f9ff;
    padding-right: 340px;
    will-change: transform;
    transition: transform 0.3s ease;
    transform: translateY(0);
    // transition: top 0.3s ease, box-shadow 0.3s ease; /* 添加对 top 的过渡 */
    .lx-btn {
      width: 200px;
      height: 56px;
      background: #0d7cd6;
      border-radius: 90px 90px 90px 90px;
      font-family: Microsoft YaHei UI, Microsoft YaHei UI;
      font-weight: 400;
      font-size: 18px;
      color: #ffffff;
      line-height: 56px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      float: right;
      margin-top: 18px;
      cursor: pointer;
    }
  }
  .searchput {
    background: #0e7cd5;
    height: 46px;
    z-index: 9999;
    width: 1490px;
    transition: all 0.3s;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    padding-right: 10px;
    input {
      width: 80%;
      height: 100%;
      padding-left: 30px;
      background: #0e7cd5;
      border: none;
      color: #ffffff;
    }
    input::placeholder {
      color: #fff; /* 设置 placeholder 文字颜色 */
      font-style: italic; /* 设置字体为斜体 */
      opacity: 1; /* 确保透明度为 1 */
    }
    input:focus {
      outline: none; /* 确保聚焦时也没有外边框 */
      // border-color: #007bff; /* 可选：自定义聚焦时的边框颜色 */
    }
    .search2 {
    }
  }
}
.nav-header {
  display: flex;
  flex-direction: column;
}
.nav-top.hide,
.tablist.hide {
  transform: translateY(-150%);
}
.nav-bar.heights {
  height: 92px;
}
.lianxi-btn.fixed {
  transform: translateY(-140px); /* 替代 top: 0 */
  z-index: 999999;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.searchput.fixed {
  transform: translateY(-140px); /* 替代 top: 0 */
  z-index: 999999;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

@media screen and (min-width: 320px) and (max-width: 768px) {
  .logoname {
    margin-right: 60px !important;
  }
  .two-tab {
    width: 420px !important;
    .two-item {
      line-height: 46px !important;
    }
  }
  .nav-top {
    // padding: 0 !important;
  }
  .tablist {
    padding: 0 50px !important;
    min-height: 90px;
    height: auto !important;
    flex-wrap: wrap;
    .two-item {
      font-size: 28px !important;
    }
    .lang-tlt {
      font-size: 20px !important;
    }
  }
  .tab-tlt {
    font-size: 28px !important;
  }
  .lianxi-btn {
    padding-right: 30px !important;
  }
  .lx-btn {
    min-width: 200px;
    width: auto !important;
    padding: 0 20px;
  }
  .lianxi-btn.fixed {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    transform: translateY(0px);
  }
  .searchput.fixed {
    position: fixed !important;
    top: 92px !important;
    left: 50% !important;
    margin-left: -745px;
    transform: translateY(-0px); /* 替代 top: 0 */
  }
}
</style>
